import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, FileDown, GitMerge } from "lucide-react";

export const DoneStep = ({ batch, onDownloadErrors, onReset }) => (
  <Card className="shadow-sm border-primary/40 fade-in" data-testid="done-panel">
    <CardContent className="p-8 space-y-5">
      <div className="flex items-center gap-3">
        <CheckCircle2 className="h-8 w-8 text-primary" />
        <h2 className="text-2xl font-serif font-semibold">All done!</h2>
      </div>
      <p className="text-lg" data-testid="done-summary">
        Added <strong>{batch.orders_added} order{batch.orders_added === 1 ? "" : "s"}</strong> — {batch.new_customers} new customer{batch.new_customers === 1 ? "" : "s"} created,{" "}
        {batch.matched_customers} order{batch.matched_customers === 1 ? "" : "s"} matched to existing customers,{" "}
        <strong>{batch.duplicates_skipped} duplicate{batch.duplicates_skipped === 1 ? "" : "s"} skipped</strong>
        {batch.flagged_matches > 0 && <>, and {batch.flagged_matches} possible duplicate{batch.flagged_matches > 1 ? "s" : ""} flagged for review</>}.
      </p>
      <div className="flex flex-wrap gap-3">
        {batch.flagged_matches > 0 && (
          <Button asChild data-testid="go-review-duplicates-btn">
            <Link to="/duplicates"><GitMerge className="h-4 w-4 mr-2" /> Review possible duplicates</Link>
          </Button>
        )}
        {batch.rows_failed > 0 && (
          <Button variant="secondary" onClick={onDownloadErrors} data-testid="download-errors-btn">
            <FileDown className="h-4 w-4 mr-2" /> Download error report ({batch.rows_failed} rows)
          </Button>
        )}
        <Button variant="secondary" asChild><Link to="/customers">View customers</Link></Button>
        <Button variant="ghost" onClick={onReset} data-testid="import-another-btn">Import another file</Button>
      </div>
    </CardContent>
  </Card>
);
